export default __webpack_public_path__ + "badc929d3e339a55ba9a0105c5505f8c.png";